<template>
    <div class="__surequote-container">
      <div class="__surequote-customer">
        <div class="__surequote-customer__details">
          <h3>Your Contact Details</h3>

          <div v-if="noProductsFound">
            <p><strong>Sorry, we did not find any products that match your criteria.</strong></p>
            <p>Please submit your details and we will be in touch.</p>
          </div>
          <div v-else>
            <p><strong>Complete our form to proceed.</strong></p>
            <p v-if="TakeCustomerDetailsFirst">To view your prices and products, fill in the form below.</p>
          </div>
          
          <p v-if="errors.length">
            <strong>Please correct the following error(s):</strong>
            <ul class="error-list">
              <li v-for="(error, i) in errors" :key="i">{{ error }}</li>
            </ul>
          </p>
          <div class="__surequote-input">
            <input type="text" v-model="name" placeholder="Your Name*">
          </div>
          <div class="__surequote-input">
            <input type="email" v-model="email" placeholder="Your Email*">
          </div>
          <div class="__surequote-input">
            <input type="tel" v-model="telephone" placeholder="Your Telephone Number*">
            <small>We use use this to text your quote</small>
          </div>
          <div v-if="showPostcodeInput" class="__surequote-input __surequote-input--postcode">
            <input type="text" v-model="postcode" placeholder="Your Postcode*">
            <small>We use this to confirm we cover your area</small>
          </div>
          <p>By continuing, you must consent to your personal data entered above being used for the purpose of contacting you to arrange a free home survey visit.</p>
          <p>We use <a href="https://www.surefiresoftware.co.uk" target="_blank">www.surefiresoftware.co.uk</a> for our Boiler Quote Engine and their <a href="https://www.surefiresoftware.co.uk/privacy-policy/" target="_blank">Privacy Policy</a> explains how they collect and store your personal data.</p>
          <div class="__surequote-input">
            <label for="__surequote-consent">
              <input id="__surequote-consent" type="checkbox" v-model="consent">
              I consent
            </label>
          </div>
          <div v-if="!TakeCustomerDetailsFirst">
            <custom-button type="success" @click.native="checkForm">Request my survey</custom-button>
          </div>
          <div v-else>
            <custom-button type="success" @click.native="checkForm">Show my prices</custom-button>
          </div>
        </div>
        <div v-if="!TakeCustomerDetailsFirst && !noProductsFound" class="surequote-products__item">
          <div class="surequote-products__section">
            <h4>You Selected</h4>
          </div>
          <product-package :pack="selectedPack" :showRequestButton="false"></product-package>
        </div>
      </div>
      <router-view name="navigation"></router-view>
    </div>
</template>

<script>
// @ is an alias to /src
import { PostcodeService } from "@/common/api.service";
import { SEARCH_POSTCODE, SELECT_ADDRESS, SAVE_CUSTOMER_DETAILS, UPDATE_CUSTOMER_DETAILS } from '@/store/actions.type.js';
import { mapGetters } from "vuex";
import ProductPackage from '@/components/ProductPackage.vue';

export default {
  name: 'customer',
  data() {
    return {
      showPostcodeInput: true,
      name: '',
      firstName: '',
      lastName: '',
      email: '',
      telephone: '',
      postcode: '',
      consent: false,
      errors: []
    }
  },
  mounted(){
    this.goToTop();
  },
  computed: {
    ...mapGetters(["selectedPack", "lookupAddresses", "customerAddress", "TakeCustomerDetailsFirst", "noProductsFound"]),
    postcodeSearchActive() {
      return this.postcode.length > 4
    }
  },
  methods: {
    goToTop(){
      var myDiv = document.getElementsByClassName('__surequote-modal');
      myDiv[0].scrollTop = 0;
    },
    checkForm(e) {
      var names = this.name.split(' ');

      this.firstName = names[0];
      this.lastName = names[1];

      if (this.firstName && this.lastName && this.email && this.telephone && this.postcode && this.consent) {
        var payload = {
          FirstName: this.firstName,
          LastName: this.lastName,
          EmailAddress: this.email,
          MobileNumber: this.telephone,
          Postcode: this.postcode
        }

        this.$store.dispatch(UPDATE_CUSTOMER_DETAILS, payload)
        this.$store.dispatch(SAVE_CUSTOMER_DETAILS);
        return true;
      }

      this.errors = [];

      if (names.length < 2) {
        this.errors.push('Full name required.');
      }

      if (!this.name) {
        this.errors.push('Name required.');
      }
      if (!this.email) {
        this.errors.push('Email required.');
      }
      if (!this.telephone) {
        this.errors.push('Telephone required.');
      }
      if (!this.postcode) {
        this.errors.push('Postcode & Address required.');
      }
      if (!this.consent) {
        this.errors.push('You must consent to the privacy policy');
      }

      e.preventDefault();
    },
    searchAddresses() {
      this.$store.dispatch(SEARCH_POSTCODE, this.postcode);      
    },
    selectAddress(address) {
      this.$store.dispatch(SELECT_ADDRESS, address)
        .then(() => {
          this.showPostcodeInput = false;
          this.goToTop();
        });
    }
  },
  components: {
    ProductPackage
  }
}
</script>
